import React, { Component } from 'react';
import { Container } from 'flux/utils';
import PropTypes from 'prop-types';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import DialogActions from '../../actions/DialogActionCreator';
import DialogStore from '../../stores/DialogStore';


class DialogWrapper extends Component {

    componentDidMount() {
        this.onSave = this.onSave.bind(this);
    }

    getActions() {
        return [
            <FlatButton key="cancel" label="Cancel" onTouchTap={this.props.onCancel} />,
            <FlatButton key="submit" label={this.props.submitLabel} onTouchTap={this.onSave} disabled={!this.state.draft.userId || !this.state.draft.status} />
        ];
    }

    render() {
        if (!this.props.open) { return null; } // guard: dialog not open

        const dialogProps = {
            title:          this.props.title,
            open:           true,
            modal:          false,
            onRequestClose: this.props.onClose,
            actions:        this.getActions()
        };

        const { children } = this.props;

        return (
            <Dialog {...dialogProps} >
                {children}
            </Dialog>
        );
    }

    onSave() {
        const saved = this.props.onSave(this.state.draft);
        if (saved !== false && !!this.props.closeOnSave) { this.props.onClose(); }
    }
}

DialogWrapper.getStores = () => ([DialogStore]);
DialogWrapper.calculateState = (prevState) => DialogStore.getState();

DialogWrapper.propTypes = {
    open:           PropTypes.bool,
    modal:          PropTypes.bool,
    isValid:        PropTypes.bool,
    title:          PropTypes.string.isRequired,
    submitLabel:    PropTypes.string,

    onClose:        PropTypes.func,
    onCancel:       PropTypes.func,
    onSave:         PropTypes.func,
    closeOnSave:    PropTypes.bool

};

DialogWrapper.defaultProps = {
    open:           true,
    modal:          false,
    isValid:        true,

    submitLabel:    'Save',
    onClose:        DialogActions.close,
    onCancel:       DialogActions.close,
    onSave:         () => true,
    closeOnSave:    true
};

export default Container.create(DialogWrapper);
